import React from 'react';
import { styled } from "@mui/material/styles";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Button, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import Image from '../../Utils/getImage';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));


const ViewPopup = ({ openviewDialog, setopenviewDialog, selectedEmployee }) => {

    //handle close
    const handleClose = () => {
        setopenviewDialog(false);
    };
    // console.log("selectedEmployee", selectedEmployee);

    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openviewDialog}
                className="admin-admins"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Employee Details
                    <Typography>
                        View the detailed information of the selected employee.
                    </Typography>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <div style={{ borderTop: "0.8px solid grey" }} ></div>
                <DialogContent dividers>
                    <section className="add-employee">
                        <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: "flex-start" }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                                <div className="add_emloyee-upload-file">
                                    <Image src={selectedEmployee?.profile_pic} alt="profile_pic" width={190} height={190} />
                                    <Typography variant="h5">{selectedEmployee?.employeeName ? selectedEmployee?.employeeName : '---'}</Typography>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 9 }}>
                                <div className='add_emloyee-content'>
                                    <div className='add_emloyee-content-text'>
                                        <Typography variant='h5'>Mobile number</Typography>
                                        <Typography>{selectedEmployee?.employeeMobile ? selectedEmployee?.employeeMobile : '---'}</Typography>
                                    </div>
                                    <div className='add_emloyee-content-text'>
                                        <Typography variant='h5'>Role</Typography>
                                        <Typography>{selectedEmployee?.employeeRole ? selectedEmployee?.employeeRole : '---'}</Typography>
                                    </div>
                                    <div className='add_emloyee-content-text'>
                                        <Typography variant='h5'>Status</Typography>
                                        <label class="switch">
                                            <input type="checkbox" checked={selectedEmployee?.Employeestatus === 'Active' ? true : false} readOnly />
                                            <span class="slider round"></span>
                                        </label>
                                    </div>
                                </div>
                                <div className='add_emloyee-content' style={{ marginTop: 20 }}>
                                    <div className='add_emloyee-content-text'>
                                        <Typography variant='h5'>Email</Typography>
                                        <Typography>{selectedEmployee?.employeeEmail ? selectedEmployee?.employeeEmail : '---'}</Typography>
                                    </div>
                                    <div className='add_emloyee-content-text'>
                                        <Typography variant='h5'>Alternate Mobile</Typography>
                                        <Typography>{selectedEmployee?.employeealtmobile ? selectedEmployee?.employeealtmobile : '---'}</Typography>
                                    </div>
                                </div>
                                <div className='add_emloyee-content' style={{ marginTop: 20 }}>
                                    <div className='add_emloyee-content-text'>
                                        <Typography variant='h5'>Address</Typography>
                                        <Typography>{selectedEmployee?.employeeAddress ? selectedEmployee?.employeeAddress : '---'}</Typography>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </section>
                </DialogContent>
                <DialogActions>
                    <Button
                        className="cancel-btn"
                        onClick={handleClose}>
                        Cancel
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    )
}

export default ViewPopup;